import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { useWebLeads } from '../lib/webData';
import { useRequests } from '../RequestsContext';

export default function WebLeads() {
  const { demo } = useAuth();
  const { data, loading } = useWebLeads(demo);
  const R = useRequests();
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const [src, setSrc] = useState<'all' | 'leads' | 'inquiries'>('all');

  const rows = useMemo(() => {
    let r = data.leads;
    if (src !== 'all') r = r.filter((x) => x.source === src);
    if (q.trim()) { const t = q.toLowerCase(); r = r.filter((x) => x.name.toLowerCase().includes(t) || (x.company || '').toLowerCase().includes(t) || (x.product || '').toLowerCase().includes(t)); }
    return r;
  }, [data, src, q]);

  const toIntake = (lead: typeof data.leads[number]) => {
    R.createRequest({ source: 'website', clientName: lead.company || lead.name, type: 'quote', contact: { name: lead.name, role: 'Buyer', email: lead.email }, summary: `${lead.product ? lead.product + ' — ' : ''}${lead.message || 'Website inquiry'}` });
    nav('/intake');
  };

  if (loading) return <div className="loading"><div className="spinner" /> Loading website leads…</div>;
  const newCount = data.leads.filter((l) => l.status === 'new').length;

  return (
    <>
      <div className="page-head">
        <div><div className="page-title">Web Leads</div><div className="page-sub">Inbound leads &amp; inquiries from microflexfilm.com — same Firestore, live.</div></div>
        {data.live ? <span className="live-flag">Live · website</span> : <span className="demo-flag">Sample data</span>}
      </div>

      <div className="grid cols-3" style={{ marginBottom: 16 }}>
        <div className="metric-card"><div className="metric-label">Total Leads</div><div className="metric-value" style={{ color: 'var(--ac)' }}>{data.leads.length}</div><div className="metric-note">leads + inquiries</div></div>
        <div className="metric-card"><div className="metric-label">New</div><div className="metric-value" style={{ color: 'var(--yl)' }}>{newCount}</div><div className="metric-note">awaiting first touch</div></div>
        <div className="metric-card"><div className="metric-label">Source</div><div className="metric-value" style={{ fontSize: 16 }}>microflexfilm.com</div><div className="metric-note">contact &amp; quote forms</div></div>
      </div>

      <div className="toolbar">
        <input className="search" placeholder="Search name, company, product…" value={q} onChange={(e) => setQ(e.target.value)} />
        <div className="seg">{(['all', 'leads', 'inquiries'] as const).map((sx) => <button key={sx} className={src === sx ? 'on' : ''} onClick={() => setSrc(sx)}>{sx === 'all' ? 'All' : sx[0].toUpperCase() + sx.slice(1)}</button>)}</div>
      </div>

      <div className="table-wrap"><table>
        <thead><tr><th>Contact</th><th>Company</th><th>Product</th><th>Industry</th><th>Source</th><th>Status</th><th>When</th><th></th></tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={8}><div className="empty">No website leads.</div></td></tr>}
          {rows.slice(0, 300).map((l) => (
            <tr key={l.id}>
              <td><strong>{l.name}</strong>{l.email && <div className="sub">{l.email}</div>}</td>
              <td>{l.company || '—'}</td>
              <td style={{ color: 'var(--tx2)' }}>{l.product || '—'}</td>
              <td style={{ color: 'var(--tx2)' }}>{l.industry || '—'}</td>
              <td><span className={`chan-badge ${l.source === 'leads' ? 'ch-portal' : 'ch-email'}`}>{l.source === 'leads' ? 'Lead' : 'Inquiry'}</span></td>
              <td><span className={`tag ${l.status === 'new' ? 'st-new' : l.status === 'contacted' ? 'st-in_progress' : 'st-completed'}`}>{l.status}</span></td>
              <td>{l.time}</td>
              <td style={{ textAlign: 'right' }}><button className="btn small primary" onClick={() => toIntake(l)}>→ Intake</button></td>
            </tr>
          ))}
        </tbody>
      </table></div>
    </>
  );
}
